import { useKeyboardControls } from "@react-three/drei";
import { useEffect, useState } from "react";
import { useControlsStore } from "./stores/useControlsStore.jsx";
import { useAudioStore } from "./stores/useAudioStore.jsx";
import { Credits } from "./components/Credits.jsx";
import { Splashscreen } from "./components/Splashscreen.jsx";
import { Loader } from "./components/Loader.jsx";

export function Interface() {
  const [isMobile, setIsMobile] = useState(false);

  // Audio state from the store
  const { isPlaying, toggleAudio, isTransitioning } = useAudioStore();

  // Controls states from the store
  const {
    moveForward,
    moveBackward,
    moveLeft,
    moveRight,
    moveUp,
    moveDown,
    setControl,
  } = useControlsStore();

  // Handlers for touch controls
  const handleTouchStart = (action) => {
    setControl(action, true);
  };

  const handleTouchEnd = (action) => {
    setControl(action, false);
  };

  // Detect if we are on mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 1000);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <>
      <Loader />
      <Splashscreen />

      {/* Overlay de transition pour le fondu au noir */}
      <div className={`transition-overlay ${isTransitioning ? "active" : ""}`}>
        <p className="transition-overlay-text">Preparing your next mood</p>
      </div>

      <div className="interface">
        {/* Credits Button */}
        <Credits />

        {/* Audio Toggle Button */}
        <button
          className="audio-toggle-button"
          onClick={toggleAudio}
          title={isPlaying ? "Mute Music" : "Unmute Music"}
        >
          {isPlaying ? "MUTE" : "UNMUTE"}
        </button>

        {/* Fish Controls Legend - Desktop only */}

        <div className="fish-controls-legend">
          <div className="legend-title">Tips</div>
          <div className="legend-item">
            <span className="key-hint">Touch the TV</span>
            <span className="action">Changing the mood</span>
          </div>
          <div className="legend-item">
            <span className="key-hint">Drag</span>
            <span className="action">Look around</span>
          </div>
        </div>
      </div>
    </>
  );
}
